import React from "react";
import { connect } from 'react-redux';
import axios from 'axios'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/stackslide.css';
import SocialNetworkForm from './SocialNetworkForm';
import { getHeader } from "../../helper";
import { getClientId, getClientSecret } from "../../components/Commons/Constants";
import { updateUserData } from '../../actions/session';

let fin = '';

class SocialNetwork extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            connecting: {},

            facebook: false,
            instagram: false,
            google: false,
            vk: false,
            twitter: false,
        }
    }

    componentDidMount() {
        this.checkChanged();

        const {location} = this.props;
        const {hash, search} = location;

        const params = new URLSearchParams(hash);
        const access_token = params.get('#access_token');
        const access_denied = params.get('#error');
        let searchParams = new URLSearchParams(search.substring(1));
        let responseParam = searchParams.get("response_vk");

        if(responseParam && access_denied) {
            this.props.history.push('/account/social-network');
        }

        if(responseParam && access_token) {
            this.props.history.push('/account/social-network');

            this.setState({
                connecting: {
                    ...this.state.connecting,
                    vk: true,
                }
            });

            const formData = new FormData();
            formData.append("grant_type", "convert_token");
            formData.append("client_id", getClientId('vk-oauth2'));
            formData.append("client_secret", getClientSecret('vk-oauth2'));
            formData.append("backend", "vk-oauth2");
            formData.append("token", access_token);
            
            this.TurnOnSocialNetwork(formData, "vk-oauth2", () => {
                this.setState({
                    connecting: {
                        ...this.state.connecting,
                        vk: false,
                    }
                });
                localStorage.setItem('vk_is_connect', true);
            });

        }
    }

    checkChanged() {
        const { currentUser } = this.props.session;
        
        currentUser.socialauth_connected.map((item, index) => {
            if (item === "facebook") {
                this.setState({ facebook: true });
            }
            if (item === "google-oauth2") {
                this.setState({ google: true });
            }
            if (item === "vk-oauth2") {
                this.setState({ vk: true });
            }
        });
    }

    handleOnChange(value, field) {
        this.setState({
            [field]: value
        })

        const { token } = this.props.session;

        if (field === 'facebook' && value === false) {
            const formData = new FormData();

            formData.append("client_id", getClientId('facebook'));
            formData.append("client_secret", getClientSecret('facebook'));
            formData.append("token", token);

            this.TurnOffSocialNetwork(formData)
        }
    }

    socialFBCallBack(response) {
        this.setState({
            connecting: {
                ...this.state.connecting,
                fb: true,
            }
        });

        const formData = new FormData();
        formData.append("grant_type", "convert_token");
        formData.append("client_id", getClientId('facebook'));
        formData.append("client_secret", getClientSecret('facebook'));
        formData.append("backend", "facebook");
        formData.append("token", response.accessToken);
        
        this.TurnOnSocialNetwork(formData, "facebook", () => {
            this.setState({
                connecting: {
                    ...this.state.connecting,
                    fb: false,
                }
            });
        });
    }

    openINST(url) {
        let URL = `https://api.instagram.com/oauth/authorize/?client_id=${getClientId('instagram')}&redirect_uri=http://fixfact.ru/acceptrequest&response_type=code`
        let win = window.open(URL, "SingleSecondaryWindowName", "width=500, height=500");
        let TurnOnSocialNetwork = this.TurnOnSocialNetwork.bind(this);

        win.addEventListener('load', function (event) {

            if(localStorage.getItem('access_token')) {
                const access_token = localStorage.getItem('access_token');

                const formData = new FormData();
                formData.append("grant_type", "convert_token");
                formData.append("client_id", getClientId('vk-oauth2'));
                formData.append("client_secret", getClientSecret('vk-oauth2'));
                formData.append("backend", "vk-oauth2");
                formData.append("token", access_token);
                
                TurnOnSocialNetwork(formData, "vk-oauth2");
                win.close();
            }
        });
    }

    TurnOnSocialNetwork(data, backend, callback) {
        const { dispatch, session:{currentUser} } = this.props;

        let backendName = ''
        if (backend === "facebook") backendName = 'Facebook'
        if (backend === "google-oauth2") backendName = 'Google'
        if (backend === "vk-oauth2") backendName = 'Вконтакте'

        axios.post(`${window.siteUrl}/api/v1/auth/convert-token/`, data)
        .then(response => {

            axios.post(
                `${window.siteUrl}/api/v1/user/${currentUser.id}/social_connect/`,
                {
                    backend,
                    converted_togen: response.data.access_token
                },
                {
                    headers: getHeader()
                }
            )
            .then(connectResponce => {

                dispatch(
                    updateUserData({
                        ...currentUser,
                        socialauth_connected: [
                            ...currentUser.socialauth_connected,
                            backend
                        ]
                    })
                )

                setTimeout(() => {
                    this.checkChanged()
                },10)

                if(callback) callback();

                Alert.success(backendName + ' успешно подключен', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
                
            })
            .catch(error => {
                if(callback) callback();

                Alert.error('Ошибка.' + backendName + ' не подключен', {
                    position: 'bottom-left',
                    effect: 'stackslide',
                    timeout: 5000
                });
            })
        })
        .catch(function (error) {
            if(callback) {
                callback();
            }

            Alert.error('Ошибка.' + backendName + ' не подключен', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });
        });
    }

    TurnOffSocialNetwork(data, backend) {
        const { dispatch, session:{currentUser} } = this.props;

        let backendName = ''
        if (backend === "facebook") backendName = 'Facebook'
        if (backend === "google-oauth2") backendName = 'Google'
        if (backend === "vk-oauth2") backendName = 'Вконтакте'

        axios.post(
            `${window.siteUrl}/api/v1/user/${currentUser.id}/social_disconnect/`, 
            data,
            {
                headers: getHeader()
            }
        )
        .then(response => {
            let newState = Object.assign([], currentUser.socialauth_connected);
            let itemIndex = currentUser.socialauth_connected.findIndex(item => item === backend);
            if(itemIndex < 0) return false;
            newState.splice(itemIndex, 1);

            dispatch(
                updateUserData({
                    ...currentUser,
                    socialauth_connected: newState
                })
            );

            setTimeout(() => {
                this.checkChanged()
            },10)

            Alert.success(backendName + ' отключен', {
                position: 'bottom-left',
                effect: 'stackslide',
                timeout: 5000
            });

        }).catch(function (error) {
            if (error.response) {
                let err = error.response;
                console.error("TurnOffSocialNetwork error-", err.status, err.data);
            }
        });
    }

    onSwitcher(state, field) {
        this.setState({
            [field]: state
        });

        if (state === false) {
            const formData = new FormData();
            field = ( field === 'google' ? 'google-oauth2' : field );
            field = ( field === 'vk' ? 'vk-oauth2' : field ) 
            formData.append('backend', field)

            this.TurnOffSocialNetwork(formData, field);
        }
    }

    socialGoogleCallback(response, state) {
        if(!state) return false;
        
        this.setState({
            connecting: {
                ...this.state.connecting,
                gl: true,
            }
        });

        const formData = new FormData();
        formData.append("grant_type", "convert_token");
        formData.append("client_id", getClientId('google-oauth2'));
        formData.append("client_secret", getClientSecret('google-oauth2'));
        formData.append("backend", "google-oauth2");
        formData.append("token", response.accessToken);
        
        this.TurnOnSocialNetwork(formData, "google-oauth2", () => {
            this.setState({
                connecting: {
                    ...this.state.connecting,
                    gl: false,
                }
            });
        });
    }

    socialInstagramCallback(response) {
        const formData = new FormData();
        formData.append("grant_type", "convert_token");
        formData.append("client_id", getClientId('instagram'));
        formData.append("client_secret", getClientSecret('instagram'));
        formData.append("backend", "facebook");
        formData.append("token", response.accessToken);
        
        this.TurnOnSocialNetwork(formData, "facebook");
    }

    handleVK() {
        let vkIsConnected = localStorage.getItem('vk_is_connect');
        let URL = "https://oauth.vk.com/authorize?client_id=6375392&display=page&redirect_uri=http://fixfact.ru/acceptrequest?response_vk=true&scope=photos,group,offline,notes,wall,notify,email&response_type=token&v=5.74";
        let URL2 = "https://oauth.vk.com/authorize?client_id=6375392&display=page&redirect_uri=http://fixfact.ru/account/social-network?response_vk=true&scope=photos,notes,group,offline,wall,notify,email&response_type=token&v=5.74";
        
        if(!vkIsConnected) {
            window.location.replace(URL2);
            return;
        }
        
        fin = window.open(URL, '_blank', "width=500, height=500");

        fin.addEventListener('beforeunload', (event) => {
     
            if(localStorage.getItem('access_token')) {

                this.setState({
                    connecting: {
                        ...this.state.connecting,
                        vk: true,
                    }
                });

                const access_token = localStorage.getItem('access_token');
                const formData = new FormData();
                formData.append("grant_type", "convert_token");
                formData.append("client_id", getClientId('vk-oauth2'));
                formData.append("client_secret", getClientSecret('vk-oauth2'));
                formData.append("backend", "vk-oauth2");
                formData.append("token", access_token);
                
                this.TurnOnSocialNetwork(formData, "vk-oauth2", () => {
                    this.setState({
                        connecting: {
                            ...this.state.connecting,
                            vk: false,
                        }
                    });
                });
            }

        });
    }

    handleTwitter() {
        this.setState({
            connecting: {
                ...this.state.connecting,
                tw: true,
            }
        });

        let URL;
        axios.get(
            `${window.siteUrl}/api/v1/social_request_twitter/`,
        )
        .then(response => {
            // this.twitterLogin2(response.data)
            let data = response.data;
            URL = `https://api.twitter.com/oauth/authenticate?${data.oauth_token}&${data.oauth_callback_confirmed}&${data.oauth_token_secret}`
            let win = window.open(URL, "SingleSecondaryWindowName", "width=500, height=500");

            win.addEventListener('load', function (event) {
            //    console.log(localStorage.getItem('access_item'));
            })
        })
        .catch(error => {
            this.setState({
                connecting: {
                    ...this.state.connecting,
                    fb: false,
                }
            });
        });
    }

    render() {
        const { errorMessages } = this.props;

        return (
            <div className="right-content native-scroll right-content-bottom right-content-width">
                <div className="screen-outer-block-wrap native-scroll menu-content">
                    <div className="menu-content-settings menu-content-item tab-parent screen-center-block">

                        <Alert stack={{ limit: 1 }} />

                        <div className="rounded-white-block">
                            <SocialNetworkForm
                                {...this.state}
                                errorMessages={errorMessages}
                                handleOnChange={(value, field) => this.handleOnChange(value, field)}
                                onSwitcher={(state, field) => this.onSwitcher(state, field)}
                                socialFBCallBack={this.socialFBCallBack.bind(this)}
                                handleINST={this.openINST.bind(this)}
                                socialGoogleCallback={this.socialGoogleCallback.bind(this)}
                                handleVK={this.handleVK.bind(this)}
                                handleTwitter={this.handleTwitter.bind(this)}
                            />
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}
export default connect(
    state => ({
        ...state
    })
)(SocialNetwork);


// WEBPACK FOOTER //
// ./src/components/Account/SocialNetwork.js